module.exports = "http://cdn.realive.com.ua/src/views/player/hudevo/phonenew/assets/images/rent.png";